module.exports = __webpack_public_path__ + "img/33.41355264.svg";